import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const StyledCarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const StyledCarouselBg = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(22, 40, 58, 0) 0%,
    rgba(22, 40, 58, 0.04) 15%,
    rgba(22, 40, 58, 0.8) 55%,
    rgba(22, 40, 58, 0.9) 75%,
    rgb(22, 40, 58) 100%
  );
  z-index: 1;
`;

export const StyledCarouselInnerBorder = styled.div`
  position: absolute;
  inset: 0;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: inherit;
  pointer-events: none;
  z-index: 3;
`;

export const StyledCarouselBgImage = styled.div`
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: opacity 0.8s ease-in-out;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
`;

export const StyledFloatingCards = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  pointer-events: none;
`;

export const StyledTransactionCard = styled.div`
  position: absolute;
  top: 40px;
  left: 73px;
  width: 343px;
  height: 150px;
  background: rgba(214, 214, 214, 0.3);
  backdrop-filter: blur(17px);
  border: 0.83px solid #f2f2f2;
  border-radius: 9.95px;
  padding: 16px 18px;
  color: #fff;
  z-index: 2;
  pointer-events: auto;
  box-shadow: 0px 33px 73px 0px rgba(0, 0, 0, 0.1),
    0px 133px 133px 0px rgba(0, 0, 0, 0.09);
`;

export const StyledTransactionCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const StyledTransactionTitle = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
`;

export const StyledCurrencyBadge = styled.span`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.1);
  padding: 2px 10px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StyledTransactionAmount = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
`;

export const StyledTransactionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const StyledTransactionBtn = styled.button`
  flex: 1;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: ${({ $primary }) =>
    $primary ? "#3636F2" : "rgba(255, 255, 255, 0.1)"};
  color: #fff;
`;

export const StyledVisaCard = styled.div`
  position: absolute;
  top: 94px;
  left: 248px;
  width: 310px;
  height: 165px;
  background: #3636f2;
  border-radius: 12px;
  padding: 20px 26px;
  color: #fff;
  overflow: hidden;
  z-index: 1;
  pointer-events: auto;
`;

export const StyledVisaAmount = styled.span`
  font-size: 18px;
  font-weight: 700;
`;

export const StyledVisaLabel = styled.span`
  font-size: 22px;
  font-weight: 800;
  font-style: italic;
  letter-spacing: 2px;
`;

export const StyledVisaIcon = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  opacity: 0.6;
`;

export const StyledCarouselContent = styled.div`
  position: relative;
  z-index: 2;
  padding: 56px 33px;
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

export const StyledCarouselHeadline = styled.h1`
  font-size: 50px;
  font-weight: 700;
  color: #fff;
  line-height: 1.3;
  white-space: pre-line;
  animation: ${fadeIn} 0.6s ease-out;
  font-family: "Montserrat", sans-serif;
`;

export const StyledCarouselSubtitle = styled.p`
  font-size: 20px;
  color: #f5f5f5;
  line-height: 1.3;
  margin: 0;
  max-width: 400px;
`;

export const StyledCarouselDots = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
`;

export const StyledCarouselDot = styled.button`
  width: ${({ $active }) => ($active ? "56px" : "8px")};
  height: 8px;
  border-radius: ${({ $active }) => ($active ? "6px" : "14px")};
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${({ $active }) =>
    $active ? "#5f5fff" : "rgba(255, 255, 255, 0.25)"};
  padding: 0;
`;
